module.exports = __webpack_public_path__ + "8f2953b60fa80673ec267850819f767b.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/nature/Desert2.jpg
// module id = 3356
// module chunks = 0